import {createContext, useContext} from 'react';
import type {AudioPlayback} from './useAudioPlayback';

const noop = () => undefined;

export const idlePlayback: AudioPlayback = {
    attachAudio: noop,
    src: null,
    canSeek: false,
    currentTime: 0,
    duration: 0,
    playing: false,
    rate: 1,
    cycleRate: noop,
    play: noop,
    pause: noop,
    toggle: noop,
    seek: noop,
    skip: noop,
};

export const PlaybackContext = createContext<AudioPlayback>(idlePlayback);

export const usePlayback = (): AudioPlayback => useContext(PlaybackContext);
